var render = function render() {
    var _vm = this, _c = _vm._self._c, _setup = _vm._self._setupProxy;
    return _c('div', {
        staticClass: "x-badge"
    }, [
        _vm._t("default"),
        _vm.dot ? _c('div', {
            staticClass: "x-badge__dot",
            style: _setup.badgeStyle
        }) : _setup.hasContent ? _c('div', {
            staticClass: "x-badge__label",
            style: _setup.badgeStyle
        }, [
            _vm._t("content", function() {
                return [
                    _vm._v(" " + _vm._s(_setup.formatContent(_vm.content)) + " ")
                ];
            })
        ], 2) : _vm._e()
    ], 2);
};
var staticRenderFns = [];
export { render, staticRenderFns };
